import * as React from 'react';
import { useTimeout } from 'usehooks-ts';

enum TimeoutState {
  Idle = 'Idle',
  Running = 'Running',
  Aborted = 'Aborted',
}

export function useTimeoutWithControl(callback: () => void, delay: number) {
  const [state, setState] = React.useState<TimeoutState>(TimeoutState.Idle);

  const start = React.useCallback(() => {
    setState(TimeoutState.Running);
  }, []);

  const abort = React.useCallback(() => {
    setState(TimeoutState.Aborted);
  }, []);

  const reset = React.useCallback(() => {
    setState(TimeoutState.Idle);
  }, []);

  const isRunning: number | null = React.useMemo(() => (state === TimeoutState.Running ? delay : null), [state, delay]);

  useTimeout(callback, isRunning);

  return { start, abort, reset, state };
}
